export const Auth_Message = 'Access Token Expired or Invalid';
export const whitelistedCountries = ['US', 'CA'];
export const whitelistedIPs = [
  '13.79.16.226',
  '52.169.108.60',
  '180.211.112.179',
  '27.56.183.218',
  '106.213.154.142',
  '182.65.193.56',
  '122.170.174.186'
];

export const defaultSelectOpt = { key: '-- Select --', value: '' };
export const defaultLabelSelectOpt = { label: '-- Select --', value: '' };

export const RESUME_FILE_ALLOW_EXTENSION = {
  REGEX: /(\.doc|\.docx|\.pdf)$/i,
  LIST: ['.doc', '.docx', '.pdf'],
  ERROR_MSG: 'Invalid file type. Please select a  doc, docx or pdf file.',
  ACCEPET_TYPE: {
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'application/pdf': ['.pdf']
  }
};

export const RESUME_UPDATE = [
  { key: 'All', value: '' },
  { key: 'Last 1 Day', value: '1' },
  { key: 'Last 1 Week', value: '7' },
  { key: 'Last 1 Month', value: '30' }
];

export const TRAVEL_RANGE = [
  { key: 'None', value: '' },
  { key: 'Upto 5 Miles', value: '5' },
  { key: 'Upto 10 Miles', value: '10' },
  { key: 'Upto 25 Miles', value: '25' },
  { key: 'Upto 50 Miles', value: '50' },
  { key: 'Upto 100 Miles', value: '100' }
];

export const TRAVEL_RANGE_PROFILE = [
  { key: 'None', value: '0' },
  { key: 'Upto 5 Miles', value: '5' },
  { key: 'Upto 10 Miles', value: '10' },
  { key: 'Upto 25 Miles', value: '25' },
  { key: 'Upto 50 Miles', value: '50' },
  { key: 'Upto 100 Miles', value: '100' }
];

export const WITHIN_CITY_RANGE = [
  { key: 'None', value: '' },
  { key: 'Upto 50 Miles', value: '50' },
  { key: 'Upto 80 Miles', value: '80' },
  { key: 'Upto 100 Miles', value: '100' },
  { key: 'Upto 120 Miles', value: '120' }
];

export const PREFERRED_WORK = [
  { key: 'Remote', value: 'Remote' },
  { key: 'On-Site', value: 'On-Site' },
  { key: 'Hybrid', value: 'Hybrid' },
  { key: 'No preference', value: 'No preference' }
];

export const TOTAL_HIRING_EXPERIENCE = [
  { key: 'Fresher', value: '0' },
  { key: '1 Year', value: '1' },
  { key: '2 Years', value: '2' },
  { key: '3 Years', value: '3' },
  { key: '4 Years', value: '4' },
  { key: '5 Years', value: '5' },
  { key: '6 Years', value: '6' },
  { key: '7 Years', value: '7' },
  { key: '8 Years', value: '8' },
  { key: '9 Years', value: '9' },
  { key: '10 Years', value: '10' },
  { key: '11 Years', value: '11' },
  { key: '12 Years', value: '12' },
  { key: '13 Years', value: '13' },
  { key: '14 Years', value: '14' },
  { key: '15 Years', value: '15' },
  { key: '16 Years', value: '16' },
  { key: '17 Years', value: '17' },
  { key: '18 Years', value: '18' },
  { key: '19 Years', value: '19' },
  { key: '20 Years', value: '20' },
  { key: '21 Years', value: '21' },
  { key: '22 Years', value: '22' },
  { key: '23 Years', value: '23' },
  { key: '24 Years', value: '24' },
  { key: '25 Years', value: '25' },
  { key: '26 Years', value: '26' },
  { key: '27 Years', value: '27' },
  { key: '28 Years', value: '28' },
  { key: '29 Years', value: '29' },
  { key: '30 Years', value: '30' }
];

export const EMPLOYER_HIRE_FOR = [
  { key: 'Executive Level', value: '4' },
  { key: 'Senior Level', value: '5' },
  { key: 'Mid Level', value: '6' },
  { key: 'Entry Level', value: '7' }
];

export const TRAVEL_REQUIREMENTS = [
  defaultSelectOpt,
  { key: 'Not Open to Travel', value: '0' },
  { key: 'Up to 25%', value: '25' },
  { key: 'Up to 50%', value: '50' },
  { key: 'Up to 75%', value: '75' },
  { key: 'Up to 100%', value: '100' }
];

export const INTERVIEW_REMIND = [
  { key: '30 Minutes Before', value: 30 },
  { key: '60 Minutes Before', value: 60 },
  { key: '90 Minutes Before', value: 90 },
  { key: '120 Minutes Before', value: 120 }
];

export const INTERVIEW_MODE = [
  { key: 'Telephonic', value: 'Telephonic' },
  { key: 'F2F', value: 'F2F' },
  { key: 'Skype', value: 'Skype' },
  { key: 'Other', value: 'Other' }
];

export const TIME_ZONE = [
  { key: 'EST', value: 'EST' },
  { key: 'PST', value: 'PST' },
  { key: 'CST', value: 'CST' }
];

export const SKILL_LEVEL = [
  { key: 'Beginner', value: 'Beginner' },
  { key: 'Intermediate', value: 'Intermediate' },
  { key: 'Expert', value: 'Expert' }
];

export const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const REMOTE_JOB_FILTER_OPT = [
  {
    value: '',
    label: 'All'
  },
  {
    value: '1',
    label: 'Remote'
  },
  {
    value: '2',
    label: 'Hybrid'
  },
  {
    value: '0',
    label: 'On-Site'
  },
  {
    value: '3',
    label: 'Flexible'
  }
];

export const WORK_ARRANGEMENT = [
  { key: 'On-Site', value: 0 },
  { key: 'Hybrid', value: 2 },
  { key: 'Remote', value: 1 },
  { key: 'Flexible', value: 3 }
];

export const SOCIAL_MEDIA = {
  FACEBOOK: 'https://www.facebook.com/OfficialVeriiPro/',
  TWITTER: 'https://www.twitter.com/VeriiPro',
  LINKEDIN: 'https://www.linkedin.com/company/veriiproofficial/',
  PINTREST: 'https://www.pinterest.com/VeriiProOfficial/'
};

export const passwordValidation = {
  regex: /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,15}$/,
  message: (prefix = '') =>
    `${
      prefix ? prefix + ' ' : ''
    }Password must be between 8 to 15 characters in length, with at least one uppercase letter, one lowercase letter, one number, and one special case character (such as !, @, #, $, %)`,
  maxLength: 15
};

export const PHONE_NUMBER_REGEX = /^(\d{10}|\d{3}-\d{3}-\d{4})$/;

export const CANDIDATE_PROFILE_GLOBAL_ERROR_MSG = 'Please fill in missing required data';

export const GENDER_OPT = [
  defaultLabelSelectOpt,
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' }
];

export const CURRENT_EMPLOYER_OPT = [
  defaultLabelSelectOpt,
  { value: 0, label: 'No' },
  { value: 1, label: 'Yes' }
];
export const WILLING_TO_RELOCATE_OPT = [
  defaultLabelSelectOpt,
  { value: '0', label: 'No' },
  { value: '1', label: 'Yes' }
];
export const WILLING_TO_COMMUTE_OPT = [
  defaultLabelSelectOpt,
  { value: '0', label: 'No' },
  { value: '1', label: 'Yes' }
];

export const CONTACT_US_SUBJECT_OPT = [
  { label: 'Job Search', value: 'Job Search' },
  { label: 'Site Issue', value: 'Site Issue' },
  { label: 'Other', value: 'Other' }
];

export const SOCKET_EVENT_NAME = {
  DISCONNECT: 'disconnect',
  CONNECT: 'connect',
  UNREAD_COUNT: 'unread_count',
  CHAT_OPEN: 'chat_open',
  SEND_MESSAGE: 'send_message',
  GET_USER_STATUS: 'get_users_status',
  CHAT_CLOSE: 'chat_close',
  NEW_MESSAGE: 'new_message',
  MESSAGE_STATUS_UPDATE: 'message_status_update',
  USER_STATUS: 'user_status',
  ALL_MESSAGE_DELIVERED: 'all_messages_delivered',
  // new
  MARK_CHAT_AS_READ: 'mark_chat_as_read',
  ALL_MESSAGE_READ: 'all_message_read',
  CHAT_UNREAD_MSG_COUNT: 'chat_unread_msg_count',
  USER_DELETE: 'user_delete',
  USER_ADD: 'user_add',
  LOGOUT_USER: 'logout_user'
};
